import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import {
  Button,
  TenderMember,
  TenderSource,
  Status,
  Owner,
  TenderPrice,
  DeliveryPlace,
  TenderTopRowInfo,
  TenderAmountOfSecurity,
  CleanNotify,
  Date,
} from 'components/UI';
import { timeInformation as TimeInformation, auction as Auction, rocket as Rocket, flag as Flag } from 'theme/icon';
import { editAccess } from 'utils/access';
import selector from 'redux_store/selectors/tenderCard/index';
import cn from 'classnames';
import { onSetOwner, getVictoryChance, getLotIdForPro, changeStatus } from 'redux_store/modules/tenderCard';
import SeldonProImg from 'theme/svg/seldon-pro.svg';
import { getPostfixProURL } from 'utils/commonFunc';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import NumberFormat from 'react-number-format';
import { History, Documents, Participants, Attributes } from './tab';
import Menu from './menu';
import Subscribe from './subscribe';
import CustomTenderActions from './tenderActions';
import Chance from './chance';

import styles from './styles.scss';

function currencyFormat(num, currency) {
  if (!num) return `${num} ${currency}`;
  return `${num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')} ${currency}`;
}

@connect(selector, { onSetOwner, getVictoryChance, getLotIdForPro })
export default class Zone extends Component {
  static propTypes = {
    tenderId: PropTypes.string.isRequired,
    tenderData: PropTypes.objectOf(PropTypes.any).isRequired,
    access: PropTypes.objectOf(PropTypes.any).isRequired,
    cardSelector: PropTypes.objectOf(PropTypes.any).isRequired,
    onSetOwner: PropTypes.func.isRequired,
    isInClean: PropTypes.bool.isRequired,
    getVictoryChance: PropTypes.func.isRequired,
    getLotIdForPro: PropTypes.func.isRequired,
    proURL: PropTypes.string.isRequired,
  };

  state = {
    chance: {
      success: false,
      chance: null,
      isRnp: false,
      rnpDate: null,
    },
    lotId: null,
    proButtonReady: !(this.props.tenderData.type && this.props.tenderData.type.id === 1),
  };

  componentDidMount() {
    if (this.props.access.isVictoryChance && this.props.access.isShowChanceData) {
      this.props
        .getVictoryChance(this.props.tenderId)
        .then(response => {
          this.setState({ chance: response });
        })
        .catch(() => {
          this.setState({ chance: { success: false } });
        });
    }
    if (this.props.tenderData.type && this.props.tenderData.type.id === 1) {
      this.props.getLotIdForPro(this.props.tenderData.lotId).then(response => {
        this.setState({ lotId: response, proButtonReady: true });
      });
    }
  }

  render() {
    const {
      tenderData,
      cardSelector: { dictionary, access: cardAccess, currentUserId },
      access,
      proURL,
      markers,
      isInClean,
    } = this.props;

    const tenderId = Number(this.props.tenderId);
    const isShowVictoryChance = access.isVictoryChance && access.isShowChanceData;
    const lotId = this.state.lotId ? this.state.lotId : tenderData.lotId;
    const postfix = this.state.lotId ? 2 : getPostfixProURL(tenderData.type ? tenderData.type.id : 1);
    const isLost = (tenderData.reportId === 100 && tenderData.purchaseTypeId !== 100) || tenderData.originalLink;
    const isDeleted = !isLost && tenderData.reportId === 1000;
    const isDocLink = !isDeleted && tenderData.originalLink && tenderData.originalLink.id;
    const isProLink =
      !isDocLink && !isDeleted && !isDocLink && tenderData.originalLink && tenderData.originalLink.notifyId;
    return (
      <div
        className={styles.wrapper}
        style={{
          backgroundColor: tenderData.tab === 'history' ? 'white' : '#f8f8f8',
        }}
      >
        {isInClean && <CleanNotify />}
        <Helmet title={`Тендер №${tenderId}`} />
        {isProLink && (
          <p className={styles.message}>
            Актуальная информация недоступна. Тендер дублирует закупку
            <a
              className={styles.link}
              target="_blank"
              // eslint-disable-next-line max-len
              href={`https://pro.myseldon.com/ru/search?requestId=00000000-0000-0000-0000-000000000000&nn=
                          ${tenderData.notificationNumber}`}
              onClick={e => e.stopPropagation()}
            >
              №{tenderData.notificationNumber}
            </a>
          </p>
        )}
        {isDocLink && (
          <p className={styles.message}>
            Актуальная информация недоступна. Дубль тендера
            <Link to={`/tender/${tenderData.originalLink.id}/history`}>
              <span>№{tenderData.originalLink.number}</span>
            </Link>
          </p>
        )}
        {(isDeleted || isLost) && (
          <p className={styles.message}>
            Актуальная информация недоступна. Отсутствует связь с источником. Возможно, тендер был удален.
            {tenderData.lostDate ? (
              <React.Fragment>{dayjs(tenderData.lostDate).utc().format(' DD MMM YYYY в HH:mm.')}</React.Fragment>
            ) : (
              '.'
            )}
          </p>
        )}
        <div className={cn(styles.header, { [styles.isDeleted]: isDocLink || isProLink || isDeleted })}>
          <div className={styles.top}>
            <div className={styles.allInfo}>
              <div className={styles.idType}>
                {!isDocLink && !isProLink && !isDeleted && (
                  <TenderTopRowInfo
                    purchaseType={tenderData.type}
                    isSMP={tenderData.isSMP}
                    electronicPlace={tenderData.trade_platform}
                    notificationNumber={tenderData.notificationNumber}
                    isDeleted={isDeleted}
                    placingWay={tenderData.placingWay}
                    link={tenderData.link}
                    view="card"
                    tradePlatforms={tenderData.trade_platforms_info}
                  />
                )}
              </div>
              <div className={cn(styles.subjectRow, { [styles.deleted]: isDeleted })}>
                <div className={styles.subject} title={tenderData.subject}>
                  {tenderData.subject || 'Наименование тендера отсутствует'}
                </div>
                {tenderData.subject !== tenderData.purchaseSubject && (
                  <div className={styles.type} title={tenderData.purchaseSubject}>
                    {tenderData.purchaseSubject}
                  </div>
                )}
              </div>
              <div className={styles.info}>
                <div className={styles.left}>
                  {!isDocLink && !isProLink && !isDeleted && (
                    <div className={styles.number}>Тендер №{tenderData.number}</div>
                  )}
                  {tenderData.organizer && (
                    <TenderMember
                      name="Организатор"
                      className={cn(isDeleted ? styles.deleted : '', styles.member)}
                      members={[
                        {
                          ...tenderData.organizer,
                          fullName: tenderData.organizer.full_name,
                          shortName: tenderData.organizer.short_name,
                        },
                      ]}
                      highlight={tenderData.organizer.short_name || tenderData.organizer.full_name}
                      tenderId={tenderData.tenderId}
                      view="card"
                    />
                  )}
                  {tenderData.customers && tenderData.customers.length > 0 && (
                    <TenderMember
                      name="Заказчик"
                      className={cn(isDeleted ? styles.deleted : '', styles.member)}
                      members={tenderData.customers.map(c => ({
                        ...c,
                        fullName: c.full_name,
                        shortName: c.short_name,
                        type: 1,
                      }))}
                      highlight={tenderData.customers[0].short_name || tenderData.customers[0].full_name}
                      tenderId={tenderData.tenderId}
                      view="card"
                    />
                  )}
                  <DeliveryPlace className={styles.deliveryPlace} data={tenderData} />
                  <TenderSource className={styles.source} insertDate={tenderData.insertDate} data={tenderData} />
                </div>
                <div
                  className={cn(styles.center, {
                    [styles.without_contract]: typeof tenderData.contractPrice !== 'number',
                  })}
                >
                  <div className={styles.price_container}>
                    <TenderPrice
                      symbol={tenderData.currency.symbol}
                      price={tenderData.price}
                      className={cn(styles.tenderPrice, { [styles.deleted]: isDeleted })}
                    />
                    {typeof tenderData.contractPrice === 'number' && (
                      <div
                        className={styles.contract_price_container}
                        title={` Конечная цена: ${currencyFormat(
                          tenderData.contractPrice,
                          tenderData.currencyContractPrice,
                        )}`}
                      >
                        <span>Конечная цена:</span>
                        <span>
                          <NumberFormat
                            key="tender-contract-price-value"
                            value={tenderData.contractPrice}
                            displayType="text"
                            thousandSeparator=" "
                            decimalSeparator=","
                            decimalprecision={2}
                          />{' '}
                          {tenderData.currencyContractPrice}
                        </span>
                      </div>
                    )}
                  </div>
                  <TenderAmountOfSecurity
                    title="Размер обеспечения заявки"
                    reportId={tenderData.reportId}
                    customers={tenderData.customers}
                    amount={tenderData.app_amount}
                    currency={tenderData.appAmountCurrency}
                  />
                  <TenderAmountOfSecurity title="Размер обеспечения контракта" customers={tenderData.customers} />
                </div>
                <div
                  className={cn(styles.right, {
                    [styles.without_contract]: typeof tenderData.contractPrice !== 'number',
                  })}
                >
                  <div className={styles.statusContainer}>
                    <Status
                      statusClassName={styles.statusWrapper}
                      subStatusClassName={styles.subStatusWrapper}
                      status={tenderData.status}
                      status1Comment={tenderData.status1Comment}
                      status2Comment={tenderData.status2Comment}
                      id={tenderData.tenderId}
                      access={
                        editAccess(
                          cardAccess.statusEdit,
                          currentUserId,
                          tenderData.user.id,
                          dictionary.userDependency,
                        ) &&
                        (!tenderData.isCustomTender || (tenderData.isCustomTender && tenderData.isActive))
                      }
                      dictionary={{ status: dictionary.status || [] }}
                      subStatus={tenderData.subStatus}
                      onEdit={changeStatus}
                    />
                  </div>
                  <Owner
                    access={
                      editAccess(cardAccess.ownerEdit, currentUserId, tenderData.user.id, dictionary.userDependency) &&
                      (!tenderData.isCustomTender || (tenderData.isCustomTender && tenderData.isActive))
                    }
                    owner={[tenderData.user]}
                    users={dictionary.owners}
                    id={tenderData.tenderId}
                    modalCaption="Выбрать ответственного"
                    onEdit={this.props.onSetOwner}
                    isSingleSelect
                    isLogo
                    isGrid={false}
                  />
                </div>
              </div>
            </div>
            <img className={cn(styles.image, { [styles.deleted]: isDeleted })} alt="" src={tenderData.pic} />
          </div>
          <div className={styles.dates}>
            <div className={styles.datesWrapper}>
              <Date
                caption="Начало подачи заявок"
                icon={<Rocket alt="" style={{ width: '24px' }} />}
                date={tenderData.startDate}
                isLast={!!tenderData.endDate || !!tenderData.auctionDate}
                tooltip={
                  tenderData.isStartDateCalculate
                    ? // eslint-disable-next-line max-len
                      'Расчетная дата начала подачи заявок, рассчитанная в соответствии с типом тендера (при отсутствии на источнике таких данных)'
                    : null
                }
                img={TimeInformation}
                diff={
                  tenderData.endDate
                    ? tenderData.endDate.utc().clone().startOf('day').diff(dayjs().utc().startOf('day'), 'days')
                    : null
                }
                styles={styles}
              />
              <Date
                caption={
                  tenderData.endDate && dayjs() > tenderData.endDate ? 'Подача заявок' : 'Окончание подачи заявок'
                }
                icon={<Flag alt="" style={{ width: '24px' }} />}
                date={tenderData.endDate}
                tooltip={
                  tenderData.isEndDateCalculate
                    ? // eslint-disable-next-line max-len
                      'Расчетная дата окончания подачи заявок, рассчитанная в соответствии с типом тендера (при отсутствии на источнике таких данных)'
                    : null
                }
                img={TimeInformation}
                isLast={!!tenderData.auctionDate}
                diff={
                  tenderData.auctionDate
                    ? tenderData.auctionDate.clone().startOf('day').diff(dayjs().startOf('day'), 'days')
                    : null
                }
                styles={styles}
              >
                {tenderData.endDate && dayjs() > tenderData.endDate && (
                  <span style={{ color: '#E30611' }}>завершена</span>
                )}
              </Date>
              {tenderData.auctionDate && (
                <Date
                  caption="Проведение аукциона"
                  icon={<Auction alt="" style={{ width: '24px' }} />}
                  date={tenderData.auctionDate}
                  isLast={false}
                  styles={styles}
                  tooltip={
                    dayjs(tenderData?.auctionDate).hour() === 0 && dayjs(tenderData?.auctionDate).minute() === 0
                      ? 'Время не определено'
                      : null
                  }
                />
              )}
            </div>
            <div
              className={cn({
                [styles.dopInfo]: true,
                [styles.dopInfoWithVictoryChange]: !this.state.chance.isRnp,
              })}
            >
              {isShowVictoryChance && (
                <Chance
                  source={tenderData.victoryChanceSource}
                  isShowChanceData={access.isShowChanceData}
                  data={this.state.chance}
                />
              )}
              {!tenderData.isCustomTender && tenderData.reportId !== 42 && !isDeleted && !isLost && (
                <a
                  style={!this.state.proButtonReady ? { pointerEvents: 'none' } : {}}
                  target="_blank"
                  href={`${proURL}/ru/tender/${lotId}-${postfix}`}
                >
                  <Button
                    color="white"
                    disabled={!this.state.proButtonReady}
                    style={{
                      fontWeight: 'bold',
                      fontSize: 13,
                      borderRadius: '2px',
                      marginRight: '8px',
                      color: '#000000',
                    }}
                  >
                    <SeldonProImg alt="" className={styles.proImage} />
                    ПОДРОБНЕЕ В PRO
                  </Button>
                </a>
              )}
              <CustomTenderActions tenderData={tenderData} markers={markers} />
            </div>
            <Subscribe data={tenderData.subscribe} tenderId={tenderId} />
          </div>
          <Menu tenderId={tenderId} tab={tenderData.tab} access={tenderData.access} />
        </div>
        <div className={styles.body}>
          {(tenderData.access.eventsView || tenderData.access.commentView) && tenderData.tab === 'history' && (
            <History
              logs={tenderData.history}
              tenderId={tenderId}
              commentAdd={tenderData.access.commentAdd}
              commentView={tenderData.access.commentView}
              documentsView={tenderData.access.documentsView}
              switchers={tenderData.switchers}
            />
          )}
          {tenderData.access.documentsView && tenderData.tab === 'documents' && (
            <Documents
              docs={tenderData.documents}
              isEditAccess={tenderData.access.documentsEdit}
              isDownloadAllInner={tenderData.access.downloadAllInnerDocuments}
              isDownloadAllPro={tenderData.access.downloadAllProDocuments}
              tenderId={tenderId}
              zoneId={tenderData.zoneId}
              userId={tenderData.userId}
              roleId={tenderData.roleId}
            />
          )}
          {tenderData.access.attributeView && tenderData.tab === 'attributes' && (
            <Attributes
              isEditAccess={tenderData.access.attributeEdit}
              tenderId={tenderId}
              zoneId={tenderData.zoneId}
              userId={tenderData.userId}
              roleId={tenderData.roleId}
            />
          )}
          {tenderData.access.participantsView && tenderData.tab === 'participants' && (
            <Participants tenderData={tenderData} />
          )}
        </div>
      </div>
    );
  }
}
